import React, { useEffect, useState } from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { ColorSchemeProvider, MantineProvider } from '@mantine/core';
import {
    RecoilRoot,
  } from 'recoil';
import PrivateRoutes from './utils/PrivateRoutes';
import ReportPage from './pages/ReportPage';
import MachinePage from './pages/MachinePage';
import TrailPage from './pages/TrailPage';
import DashBoardPage from './pages/DashBoardPage';
import Home from './components/home/Home';
import PageNotFound404 from './pages/PageNotFound404';
import LoginPage from './pages/LoginPage';
import PdfExport from './components/PdfExports/PdfExport';
import AlarmCard from './components/cards/AlarmCard';
import SubMachine from './pages/SubMachine';



function App() {

 
 
  const [colorScheme, setColorScheme] = useState('light')
  const toggleColorScheme = (value) => setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'))
  
  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
   <MantineProvider theme={{colorScheme}} withGlobalStyles withNormalizeCSS>
    <RecoilRoot>
    <Router>
            <Routes>
              <Route exact path='/about' element={<Home/>} />
              {/* <Route exact path='/login' element={window.localStorage.getItem('username') !== undefined  ? <Navigate to={'/app/dashboard'}/> : <LoginPage/>}/> */}
              <Route exact path='/login' element={ <LoginPage/>}/>
              <Route exact path='/app' element={<PrivateRoutes/>}>
                  <Route exact path='dashboard'  element={ <DashBoardPage /> } />
                  <Route exact path='machine' element={ <MachinePage /> }/> 
                  <Route exact path='trail' element={  <TrailPage /> } />
                  <Route exact path='report' element={ <ReportPage />} />
                  <Route exact path='submachine/:machine/:nodeid' element={ <SubMachine/>} />
                  {/* <Route exact path='settings' element={ <SettingsPage />} /> */}
              </Route>  

              <Route exact path='/' element={ window.localStorage.getItem('token') ? <Navigate to={'/app/dashboard'}/> : <Navigate to='/login'/>} /> 
              
                <Route path='*' element={<PageNotFound404/>}/>  
                <Route path='/test' element={<PdfExport/>}/>
                <Route path='/alarm' element={<AlarmCard/>}/>
              </Routes>
           </Router>
    </RecoilRoot>
      </MantineProvider>
      </ColorSchemeProvider>
      
  );
}

export default App;

